import React, { useState, useEffect } from 'react';
import { getMapStateToProps } from '@/utils/utils';
import { connect } from 'dva';
import { ConfigProvider } from 'antd';
import en_US from 'antd/es/locale/en_US';
import zh_CN from 'antd/es/locale/zh_CN';
import zh_TW from 'antd/es/locale/zh_TW';
import ru_RU from 'antd/es/locale/ru_RU';
import ja_JP from 'antd/es/locale/ja_JP';
import fr_FR from 'antd/es/locale/fr_FR';
import de_DE from 'antd/es/locale/de_DE';
import it_IT from 'antd/es/locale/it_IT';
import es_ES from 'antd/es/locale/es_ES';
import ko_KR from 'antd/es/locale/ko_KR';
import imageSettings from '@/constants/ImageSettings';
import { Helmet } from 'react-helmet';
import metaSettings from '../../config/metaSettings';

const antdLanSelect = {
  en_AU: en_US,
  zh_CN,
  zh_HK: zh_TW,
  ru_RU,
  ja_JP,
  fr_FR,
  de_DE,
  it_IT,
  es_ES,
  ko_KR,
};

const useWindowSize = () => {
  const isClient = typeof window === 'object';

  const getSize = () => ({
    width: isClient ? window.innerWidth : undefined,
    height: isClient ? window.innerHeight : undefined,
  });

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect((): any => {
    if (!isClient) {
      return false;
    }

    const handleResize = () => {
      setWindowSize(getSize());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
};

// 改favicon和title
const handleIconAndTitleChange = () => {
  const getFaviconEl = () => document.getElementById('favicon');

  // Accessing favicon element
  let favicon: any = getFaviconEl();
  favicon.href = imageSettings[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || ''].favicon;

  // Accessing title element
  document.getElementById('title')!.innerText =
    imageSettings[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || ''].title;
};

const Layout: React.FC<any> = props => {
  const { dispatch, meta, children } = props;

  useEffect(() => {
    // // 改favicon和title
    handleIconAndTitleChange();
  }, []);

  const size = useWindowSize();

  const isMobile = (size.width as number) <= 767 ? true : false;
  const isXs = (size.width as number) <= 576 ? true : false;

  if (isMobile !== meta.isMobile || isXs !== meta.isXs) {
    dispatch({
      type: 'meta/setMobileType',
      width: size.width as number,
    });
  }

  const logoText = imageSettings[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || 'unset'].logoText;
  const favicon = imageSettings[POPSUP_WASHOKU_ONLY_SEVER_ENV_KEY || 'unset'].favicon;

  return (
    <ConfigProvider locale={antdLanSelect[meta.viewingLang]}>
      <Helmet>
        <title>{logoText}</title>
        <link rel="icon" href={favicon} id="favicon" type="image/x-icon" />
      </Helmet>
      {children}
    </ConfigProvider>
  );
};

export default connect(getMapStateToProps(['meta', 'od', 'user']))(Layout);
